import { InfoCard } from "./InfoCard";
import { QuickActions } from "./QuickActions";
import { BasicDetail } from "./tabs/BasicDetail";
import { Tabs } from "@shared/ui/tabs";
import { Button } from "@shared/ui/button";
import { ArrowLeft, ClipboardList, Receipt, Activity, BadgeCheck, Hammer, Timer } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetFieldForceDetails } from "../../hooks";

import { TransactionsTab } from "../fieldForceView/tabs/transactions";
import { ActivityTab } from "../fieldForceView/tabs/activityLog";
import ServiceOrders from "./tabs/ServiceOrders";
import { ActivityLogTab } from "@features/wx/shared/ActivityLog";

export const Landing = () => {
    const { id, ff_no } = useParams<{ id: string; ff_no: string }>();
    const navigate = useNavigate();
    const { data: technician } = useGetFieldForceDetails(ff_no || "");

    const handleBackToList = () => {
        navigate("/service-orders/field-force/");
    };

    const tabComponents = {

        basicDetails: {
            label: "Basic Details",
            shortLabel: "Basic Details",
            icon: <ClipboardList size={16} />,
            component: <BasicDetail technician={technician} />,
        },
        serviceOrders: {
            label: "Service Orders",
            shortLabel: "Service Orders",
            icon: <Receipt size={16} />,
            component: <ServiceOrders ff_no={ff_no} />
        },
        activityLog: {
            label: "Activity Log",
            shortLabel: "Activity Log",
            icon: <Activity size={16} />,
            component: <ActivityLogTab entityId={id} entityType="1" />,
        },

    };


    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex items-center gap-4 mb-2">
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={handleBackToList}
                    className="h-8 w-8 rounded-full hover:bg-gray-100"
                >
                    <ArrowLeft className="h-5 w-5 text-gray-700" />
                </Button>
                <div>
                    <h1 className="text-xl font-bold text-gray-900">{technician?.name || "Loading..."}</h1>
                    <p className="text-sm text-gray-500 font-medium">
                        {technician?.roleName || "Field Force"}
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-12 gap-6">
                <div className="col-span-12 lg:col-span-9">
                    <InfoCard />
                </div>
                <div className="col-span-12 lg:col-span-3">
                    <QuickActions />
                </div>
            </div>

            <div className="pt-4">
                <Tabs
                    defaultValue="basicDetails"
                    tabComponents={tabComponents}
                        tabsListClassName="grid grid-cols-3"
                />
            </div>
        </div>
    );
};
